import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  async loadData (context) {
    context.commit('SET_RELOADING_DEVICES', true)
    await context.dispatch('clearList')
    context.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', 'Loading device list...', { root: true })
    await context.dispatch('getDeviceList')
    context.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', 'Loading device groups...', { root: true })
    await context.dispatch('getDeviceDesktopGroups')
    context.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', 'Loading pending content...', { root: true })
    await context.dispatch('getDeviceDesktopsAffected')
    context.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', 'Loading content downloads...', { root: true })
    await context.dispatch('getContentDownloads')
    context.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', 'Loading device tags...', { root: true })
    await context.dispatch('setDeviceTags')
    await context.dispatch('setUnusedTags')
    await context.commit('SET_RELOADING_DEVICES', false)
    setTimeout(() => {
      context.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', undefined, { root: true })
    }, 500)
  },
  async getDeviceList (context) {
    context.commit('SET_DEVICELIST', (await Vue.axios.get('device/list')).data)
    context.commit('SET_DESKTOPLIST', (await Vue.axios.get('devicedesktop/list')).data)
  },
  activateWsListener (context) {
    // Vue.$io.socket.off('LOST_HB')
    // Vue.$io.socket.on('LOST_HB', function (data) {
    //   // console.log('Got Websocket info - LOST_HB', data)
    //   context.commit('LOST_HB', data)
    // })
    // Vue.$io.socket.off('RECOVERED_HB')
    // Vue.$io.socket.on('RECOVERED_HB', function (data) {
    //   // console.log('Got Websocket info - RECOVERED_HB', data)
    //   context.commit('RECOVERED_HB', data)
    // })
    Vue.$io.socket.off('content_update_progress')
    Vue.$io.socket.on('content_update_progress', data => {
      if (!this.state.User.liveMode.contentUpdateProgress) return
      context.commit('UPDATE_PROGRESS', data)
    })
    Vue.$io.socket.off('dplm_destroyed')
    Vue.$io.socket.on('dplm_destroyed', data => {
      if (!this.state.User.liveMode.contentPending) return
      context.commit('DELETE_DESKTOP_AFFECTED', data.id)
    })
    Vue.$io.socket.off('dplm_created')
    Vue.$io.socket.on('dplm_created', data => {
      if (!this.state.User.liveMode.contentPending) return
      context.commit('ADD_DESKTOP_AFFECTED', data)
    })
    Vue.$io.socket.off('dplm_updated')
    Vue.$io.socket.on('dplm_updated', data => {
      // console.log('Got Websocket info - dplm_updated', data)
      // context.commit('DELETE_DESKTOP_AFFECTED', data.id)
      // context.commit('ADD_DESKTOP_AFFECTED', data)
    })
  },
  async getDeviceDesktopsAffected (context) {
    const desktopsAffected = (await Vue.axios.get('desktopplaylistmodification')).data
    context.commit('SET_DESKTOPS_AFFECTED', desktopsAffected)
    return desktopsAffected
  },
  async setDeviceTags (context) {
    await Vue.axios
      .get('devicetag/list')
      .then(response => {
        context.commit('SET_DEVICE_TAGS', response.data)
      })
  },
  async setUnusedTags (context) {
    await Vue.axios.get('DeviceTag/findUnused')
      .then(response => {
        context.commit('SET_DEVICE_TAGS_UNUSED', response.data)
      })
  },
  clearList (context) {
    context.commit('SET_DEVICELIST', [])
    context.commit('CLEAR_DESKTOPS_SELECTED_LEFT')
    context.commit('CLEAR_DESKTOPS_SELECTED_RIGHT')
    context.commit('PAGINATION_SET_PAGE', ['left', 1])
    context.commit('PAGINATION_SET_PAGE', ['right', 1])
    context.commit('SET_DEVICE_TAGS_UNUSED', [])
    context.commit('CLEAR_DEVICE_TAGS', [])
    context.commit('SET_CONTENT_DOWNLOADS', [])
    context.commit('SET_DESKTOPS_AFFECTED', [])
    context.commit('CLEAR_TYPE_FILTER', 'left')
    context.commit('CLEAR_TYPE_FILTER', 'right')
  },
  /** TAGS */
  async replaceDeviceTagsInDevice (context, [tagIdsArray, deviceId]) {
    await Vue.axios.put('device/' + deviceId + '/DeviceTags', tagIdsArray)
    await Vue.axios.post('device/createModificationsForDevice', { deviceId })
    await context.dispatch('setUnusedTags')
    await context.dispatch('setDeviceTags')
  },
  async saveDeviceTagInNetwork (context, tag) {
    await Vue.axios.patch('devicetag/' + tag.id, { name: tag.name })
    await context.dispatch('loadData')
  },
  async destroy (context, deviceId) {
    await Vue.axios.post('device/destroy', { id: deviceId })
  },
  async deleteDeviceTagFromNetwork (context, tagId) {
    await Vue.axios.delete('devicetag/' + tagId)
    await context.dispatch('loadData')
  },
  async addDeviceTag (context, tagname) {
    const tag = (await Vue.axios.post('devicetag', { 'name': tagname })).data
    context.commit('ADD_DEVICE_TAG_TO_NETWORK_DEVICE_TAGS', tag)
    return tag
  },
  async clearDeviceTagsFromDevice (context, device) {
    const deviceId = isNaN(device) && device.id ? device.id : device
    await Vue.axios.put('device/' + deviceId + '/devicetags', [])
    context.commit('CLEAR_TAGS_FROM_DEVICE', deviceId)
  },
  async clearTimeRestrictions (context, device) {
    const deviceId = isNaN(device) && device.id ? device.id : device
    await Vue.axios.put('device/' + deviceId + '/Device_DateRestrictions', [])
    await Vue.axios.put('device/' + deviceId + '/Device_DaytimeRestrictions', [])
  },
  async deleteDeviceTagFromDevice (context, data) {
    data[1] = isNaN(data[1]) && data[1].id ? data[1].id : data[1]
    const result = await Vue.axios.post('devicetag/removeFromDevice', {
      deviceId: data[1],
      tagId: data[0]
    })
    if (result.data === 'removed') {
      context.commit('DELETE_TAG_FROM_DEVICE', data)
    }
  },
  async addDeviceTagToDevice (context, data) {
    data[1] = isNaN(data[1]) && data[1].id ? data[1].id : data[1]
    const result = await Vue.axios.post('devicetag/addToDevice', {
      deviceId: data[1],
      tagId: data[0]
    })
    if (result.data === 'added') {
      context.commit('ADD_TAG_TO_DEVICE', data)
    }
  },
  /** END TAGS */
  async assignDesktopToGroup (context, data) {
    await Vue.axios.patch('devicedesktop/' + data[0], { 'DeviceDesktopGroup': data[1] })
  },
  async destroyDesktopGroup (context, devicedesktopgroup) {
    context.commit('SET_RELOADING_DEVICES', true)
    await Vue.axios.delete('devicedesktopgroup/' + devicedesktopgroup.id)
      .then(response => {
        context.dispatch('getDeviceDesktopGroups')
        context.commit('SET_RELOADING_DEVICES', false)
      })
  },
  async getContentDownloads (context) {
    await Vue.axios.get('/contentdownload/getLastContentDownloadsForNetwork')
      .then(response => {
        context.commit('SET_CONTENT_DOWNLOADS', response.data)
      })
  },
  deleteContentDownload (context, contentDownloadId) {
    context.commit('DELETE_CONTENT_DOWNLOAD', contentDownloadId)
  },
  toggleTagToTagFilter (context, tag) {
    context.commit('TOGGLE_TAG_TO_TAG_FILTER', tag)
  },

  // Used in EditMonitorsDesktops.vue
  updateDesktops (context, deviceUpdated) {
    context.commit('UPDATE_DESKTOPS_IN_DEVICE', deviceUpdated)
  },

  async reloadDeviceFromApi (context, deviceId) {
    context.commit('SET_RELOADING_DEVICES', true)
    const device = (await Vue.axios.get(`device/${deviceId}`)).data
    context.commit('UPDATE_DEVICELIST', device)
    for (const deviceDesktop of device.DeviceDesktops) {
      if (deviceDesktop.DeviceDesktopGroup) {
        context.dispatch('reloadDeviceDesktopGroupFromApi', deviceDesktop.DeviceDesktopGroup)
      }
    }
    context.commit('SET_RELOADING_DEVICES', false)
  },
  updateCollection (context, data) {
    context.commit('SET_RELOADING_DEVICES', true)
    context.commit('UPDATE_DEVICELIST', data)
    context.commit('SET_RELOADING_DEVICES', false)
  },
  updateDesktopHB (context, data) {
    context.commit('UPDATE_DESKTOP_HB', data)
  },
  updateDesktop (context, desktop) {
    context.commit('UPDATE_DESKTOP', desktop)
  },
  addMonitor (context, monitor) {
    context.commit('ADD_MONITOR', monitor)
  },
  deleteMonitor (context, monitor) {
    context.commit('DELETE_MONITOR', monitor)
  },
  /** RESTRICTIONS */
  async addDeviceDateRestriction (context, data) {
    await Vue.axios.post('Device_DateRestriction', data)
      .then(response => {
        // TODO - If we want to display restrictions on list
        // context.commit('ADD_DATE_RESTRICTION_TO_STORE ', response.data)
      })
  },
  async addDeviceDaytimeRestriction (context, data) {
    await Vue.axios.post('Device_DaytimeRestriction', data)
      .then(response => {
        // TODO - If we want to display restrictions on list
        // context.commit('ADD_DAYTIMERESTRICTION_TO_STORE ', response.data)
      })
  },
  /** SELECTIONS */
  addDesktopsSelectedRight (context, desktops) {
    context.commit('ADD_DESKTOPS_SELECTED_RIGHT', desktops)
  },
  toggleDesktopSelectedRight (context, desktops) {
    context.commit('TOGGLE_DESKTOP_SELECTED_RIGHT', desktops)
  },
  clearDesktopsSelectedRight (context) {
    context.commit('CLEAR_DESKTOPS_SELECTED_RIGHT')
  },
  removeDesktopSelectedRight (context, desktop) {
    context.commit('REMOVE_DESKTOP_SELECTED_RIGHT', desktop)
  },
  addDesktopGroupsSelectedRight (context, groups) {
    context.commit('ADD_DESKTOP_GROUPS_SELECTED_RIGHT', groups)
  },
  toggleDesktopGroupsSelectedRight (context, groups) {
    context.commit('TOGGLE_DESKTOP_GROUP_SELECTED_RIGHT', groups)
  },
  clearDesktopGroupsSelectedRight (context) {
    context.commit('CLEAR_DESKTOP_GROUPS_SELECTED_RIGHT')
  },
  /** FILTERS */
  setTagsInFilter (context, data) {
    context.commit('SET_TAGS_IN_FILTER', data)
  },
  toggleTagInFilter (context, data) {
    context.commit('TOGGLE_TAG_IN_FILTER', data)
  },
  toggleTypeInFilter (context, data) {
    context.commit('TOGGLE_TYPE_IN_FILTER', data)
  },
  setTypeInFilter (context, data) {
    context.commit('SET_TYPE_IN_FILTER', data)
  },
  toggleTagFilterVisible (context) {
    context.commit('TOGGLE_TAG_FILTER_VISIBLE')
  },
  setBiggestTypeInFilter (context, side) {
    context.commit('SET_BIGGEST_TYPE_IN_FILTER', side)
  },
  setTagAllAnyInFilter (context, data) {
    context.commit('SET_TAG_ALLANY_IN_FILTER', data)
  },
  clearFilter (context, side) {
    context.commit('CLEAR_TAG_FILTER', side)
  },
  /** PAGINATION */
  paginationSetLimit (context, data) {
    context.commit('PAGINATION_SET_LIMIT', data)
  },
  paginationSetPage (context, data) {
    context.commit('PAGINATION_SET_PAGE', data)
  },
  paginationSetLimitGroups (context, data) {
    context.commit('PAGINATION_SET_LIMIT_GROUPS', data)
  },
  paginationSetPageGroups (context, data) {
    context.commit('PAGINATION_SET_PAGE_GROUPS', data)
  },
  /** DEVICE GROUPS */
  async getDeviceDesktopGroups (context) {
    const path = 'DeviceDesktopGroup/list'
    context.commit('SET_RELOADING_DEVICES', true)
    await Vue.axios.get(path)
      .then(response => {
        context.commit('SET_DEVICE_DESKTOP_GROUPS', response.data)
        context.commit('SET_RELOADING_DEVICES', false)
      })
  },
  async reloadDeviceDesktopGroupFromApi (context, groupId) {
    context.commit('SET_RELOADING_DEVICES', true)
    context.commit('UPDATE_DEVICE_DESKTOP_GROUP', (await Vue.axios.get(`devicedesktopgroup/${groupId}`)).data)
    context.commit('SET_RELOADING_DEVICES', false)
  },
  addDesktopGroup (context, group) {
    context.commit('SET_RELOADING_DEVICES', true)
    context.commit('ADD_DEVICE_DESKTOP_GROUP', group)
    context.commit('SET_RELOADING_DEVICES', false)
  },
  /** Store cache for desktop list */
  setDesktopListCache (context, desktops) {
    context.commit('SET_DESKTOP_CACHE', desktops)
  }
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/device/device.actions.js
// module id = null
// module chunks = 